// GENERATED by scripts/sync-icons.mjs from icons.config.json. Do not edit.
// Hugeicons (pro-stroke-sharp).
// Keep this repository private: this is a subset of a licensed icon set.

/** SVG elements of an icon, as [tag, attributes]. */
export type IconData = readonly (readonly [string, Readonly<Record<string, string | number>>])[];

/** Which Hugeicons set these were generated from. */
export const ICON_SET = 'pro-stroke-sharp' as const;

const data = {
  /** Home01Icon */
  home: [
    ['path', { d: 'M3 9V21.5H21V9L12 2.5L3 9Z', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
  ],
  /** Notification03Icon */
  notification: [
    [
      'path',
      {
        d: 'M20 18.5011L18.349 7.93407C17.8603 4.80601 15.166 2.5 12 2.5C8.83398 2.5 6.13971 4.80601 5.65098 7.93407L4 18.5011',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M20 18.5C20 16.8431 16.4183 15.5 12 15.5C7.58172 15.5 4 16.8431 4 18.5C4 20.1569 7.58172 21.5 12 21.5C16.4183 21.5 20 20.1569 20 18.5Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    ['path', { d: 'M13 18.5H11', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
  ],
  /** Calendar03Icon */
  calendar: [
    ['path', { d: 'M16.5 2V6M7.5 2V6', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M21 4H3V22H21V4Z', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M3 10H21', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    [
      'path',
      {
        d: 'M12.1258 14H12.0008M12.1258 18H12.0008M7.625 14H7.5M7.625 18H7.5M16.625 14H16.5M12.2508 14C12.2508 14.1381 12.1389 14.25 12.0008 14.25C11.8628 14.25 11.7508 14.1381 11.7508 14C11.7508 13.8619 11.8628 13.75 12.0008 13.75C12.1389 13.75 12.2508 13.8619 12.2508 14ZM12.2508 18C12.2508 18.1381 12.1389 18.25 12.0008 18.25C11.8628 18.25 11.7508 18.1381 11.7508 18C11.7508 17.8619 11.8628 17.75 12.0008 17.75C12.1389 17.75 12.2508 17.8619 12.2508 18ZM7.75 14C7.75 14.1381 7.63807 14.25 7.5 14.25C7.36193 14.25 7.25 14.1381 7.25 14C7.25 13.8619 7.36193 13.75 7.5 13.75C7.63807 13.75 7.75 13.8619 7.75 14ZM7.75 18C7.75 18.1381 7.63807 18.25 7.5 18.25C7.36193 18.25 7.25 18.1381 7.25 18C7.25 17.8619 7.36193 17.75 7.5 17.75C7.63807 17.75 7.75 17.8619 7.75 18ZM16.75 14C16.75 14.1381 16.6381 14.25 16.5 14.25C16.3619 14.25 16.25 14.1381 16.25 14C16.25 13.8619 16.3619 13.75 16.5 13.75C16.6381 13.75 16.75 13.8619 16.75 14Z',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** PieChartIcon */
  chart: [
    [
      'path',
      {
        d: 'M20.5 15.8278C17.9985 21.756 9.86407 23.4835 5.20143 18.8641C0.629484 14.3347 2.04493 6.12883 8.05653 3.5',
        stroke: 'currentColor',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M21.4718 12.5C21.671 9.85979 20.82 7.13848 18.7986 5.13585C16.7723 3.12841 14.0904 2.31961 11.5 2.5333V12.5H21.4718Z',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** Analytics01Icon */
  analytics: [
    ['path', { d: 'M7 17L7 13', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M12 17L12 7', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M17 17L17 11', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M21 3V21H3V3H21Z', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
  ],
  /** ArrowDown01Icon */
  chevronDown: [['path', { d: 'M5.99977 9.00005L11.9998 15L17.9998 9', stroke: 'currentColor', strokeWidth: '1.5' }]],
  /** ArrowUp01Icon */
  chevronUp: [['path', { d: 'M18 15L12 9L6 15', stroke: 'currentColor', strokeWidth: '1.5' }]],
  /** ArrowLeft01Icon */
  chevronLeft: [['path', { d: 'M15 6L9 12L15 18', stroke: 'currentColor', strokeWidth: '1.5' }]],
  /** ArrowRight01Icon */
  chevronRight: [['path', { d: 'M9.00005 6L15 12L9 18', stroke: 'currentColor', strokeWidth: '1.5' }]],
  /** ArrowLeftDoubleIcon */
  chevronsLeft: [
    ['path', { d: 'M11.5 6L5.5 12L11.5 18', stroke: 'currentColor', strokeWidth: '1.5' }],
    ['path', { d: 'M18.5 6L12.5 12L18.5 18', stroke: 'currentColor', strokeWidth: '1.5' }],
  ],
  /** ArrowRightDoubleIcon */
  chevronsRight: [
    ['path', { d: 'M12.5 6L18.5 12L12.5 18', stroke: 'currentColor', strokeWidth: '1.5' }],
    ['path', { d: 'M5.5 6L11.5 12L5.50005 18', stroke: 'currentColor', strokeWidth: '1.5' }],
  ],
  /** UnfoldMoreIcon */
  sort: [
    ['path', { d: 'M18 9.99996L12 5L6 10', stroke: 'currentColor', strokeWidth: '1.5' }],
    ['path', { d: 'M18 14L12 19L6 14', stroke: 'currentColor', strokeWidth: '1.5' }],
  ],
  /** ArrowUp02Icon */
  arrowUp: [
    ['path', { d: 'M18 11L12 5L6 11M12 5.5V19', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
  ],
  /** ArrowUpRight01Icon */
  arrowUpRight: [
    [
      'path',
      {
        d: 'M17.5 15V6.5H9.00003M17.0714 6.9286L6.50003 17.5',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** ArrowDownLeft01Icon */
  arrowDownLeft: [
    [
      'path',
      {
        d: 'M6.50003 9V17.5H15M6.92857 17.0714L17.5 6.5',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** ArrowTurnBackwardIcon */
  reply: [
    [
      'path',
      {
        d: 'M8.223 10.0451L4.26073 14.0343L8.21781 17.9982M4 14.0215H16.057C18.2347 14.0215 20 12.2263 20 10.0117C20 7.79719 18.2347 6.00195 16.057 6.00195H11.185',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** ArrowTurnForwardIcon */
  forward: [
    [
      'path',
      {
        d: 'M15.9476 9.86828L20 14.238L15.9476 18.5016M13.0748 5.49854H8.05922C5.81737 5.49854 4 7.45494 4 9.86828C4 12.2816 5.81737 14.238 8.05922 14.238H19.6064',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** Settings02Icon */
  settings: [
    [
      'path',
      {
        d: 'M15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12Z',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M22 13.9669V10.0332C19.1433 10.0332 17.2857 6.93041 18.732 4.46691L15.2679 2.5001C13.8038 4.99405 10.1978 4.99395 8.73363 2.5L5.26953 4.46681C6.71586 6.93035 4.85673 10.0332 2 10.0332V13.9669C4.85668 13.9669 6.71425 17.0697 5.26795 19.5332L8.73205 21.5C10.1969 19.0048 13.8046 19.0047 15.2695 21.4999L18.7336 19.5331C17.2874 17.0696 19.1434 13.9669 22 13.9669Z',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** DollarCircleIcon */
  money: [
    [
      'path',
      {
        d: 'M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z',
        stroke: 'currentColor',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M12 6.5V8M12 8C10.4812 8 9.25 8.92865 9.25 10.0741C9.25 11.2196 10 11.8519 12 11.8519C14 11.8519 15 12.4445 15 13.926C15 15.4075 13.6569 16 12 16M12 8C13.5188 8 14.75 8.92865 14.75 10.0741M12 16V17.5M12 16C10.3431 16 9 15.0715 9 13.926',
        stroke: 'currentColor',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** CreditCardIcon */
  payment: [
    [
      'path',
      {
        d: 'M22 4H2V20H22V4Z',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
    ['path', { d: 'M11 16H13M15 16L19 16', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    [
      'path',
      { d: 'M2 9H22', stroke: 'currentColor', strokeLinecap: 'square', strokeLinejoin: 'round', strokeWidth: '1.5' },
    ],
  ],
  /** ShoppingCart01Icon */
  cart: [
    [
      'path',
      {
        d: 'M10.5 20.25C10.5 20.6642 10.1642 21 9.75 21C9.33579 21 9 20.6642 9 20.25C9 19.8358 9.33579 19.5 9.75 19.5C10.1642 19.5 10.5 19.8358 10.5 20.25Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M19 20.25C19 20.6642 18.6642 21 18.25 21C17.8358 21 17.5 20.6642 17.5 20.25C17.5 19.8358 17.8358 19.5 18.25 19.5C18.6642 19.5 19 19.8358 19 20.25Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M2 3H3.60332C4.39028 3 5.04344 3.60817 5.09951 4.39313L5.60196 11.4275C5.82624 14.5673 8.43888 17 11.5867 17H16C19.3137 17 22 14.3137 22 11V6H5.5',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    ['path', { d: 'M16 10V13M11 10V13', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
  ],
  /** Upload04Icon */
  upload: [
    [
      'path',
      {
        d: 'M21 20.9999V16.4999H16L14.5 17.9999H9.5L8 16.4999H3V20.9999H21Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M7.5 7.49988L12 2.99988L16.5 7.49988M12 3.99988V14.9999',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** Download04Icon */
  download: [
    [
      'path',
      {
        d: 'M7.00004 11.5L12 17.5L17 11.5H14L14 3H10L10 11.5H7.00004Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    ['path', { d: 'M5.00005 21H19', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
  ],
  /** FileExportIcon */
  export: [
    [
      'path',
      { d: 'M13 2.5V9H19.5M20 14V9L13 2H4V22H10', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
    ['path', { d: 'M17 22L20 19L17 16M19 19H12', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
  ],
  /** Mail01Icon */
  email: [
    ['path', { d: 'M2 3.5H22V20.5H2V3.5Z', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M2 7L12 12L22 7', stroke: 'currentColor', strokeWidth: '1.5' }],
  ],
  /** CallIcon */
  phone: [
    [
      'path',
      {
        d: 'M5 10.5L8.5 7C8.5 7 7.64666 5.22175 7.5 3H3C3 12.9411 11.0589 21 21 21V16.5C18.7782 16.3533 17 15.5 17 15.5L13.5 19',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** CallEnd01Icon */
  endCall: [
    [
      'path',
      {
        d: 'M5 10.5L8.5 7C8.5 7 7.64666 5.22175 7.5 3H3C3 12.9411 11.0589 21 21 21V16.5C18.7782 16.3533 17 15.5 17 15.5L13.5 19',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    ['path', { d: 'M20 4L14 10M20 10L14 4', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
  ],
  /** ContactBookIcon */
  contact: [
    ['path', { d: 'M22 2H5V22H22V2Z', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M5 6H2M5 12H2M5 18H2', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    [
      'path',
      {
        d: 'M15.5 8.5C15.5 9.60457 14.6046 10.5 13.5 10.5C12.3954 10.5 11.5 9.60457 11.5 8.5C11.5 7.39543 12.3954 6.5 13.5 6.5C14.6046 6.5 15.5 7.39543 15.5 8.5Z',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M17.5 17.5H9.5C9.5 15.0454 11.2909 13.5 13.5 13.5C15.7091 13.5 17.5 15.0454 17.5 17.5Z',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** ViewIcon */
  show: [
    [
      'path',
      {
        d: 'M15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12Z',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M12 5C17.5228 5 22 12 22 12C22 12 17.5228 19 12 19C6.47715 19 2 12 2 12C2 12 6.47715 5 12 5Z',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** ViewOffSlashIcon */
  hide: [
    [
      'path',
      {
        d: 'M19.439 15.439C21 14 22 12 22 12C20.5 9 16.6892 5 12 5C11.0922 5 10.2294 5.15476 9.41827 5.41827M17 17.4186C15.5657 18.3368 13.8793 19 12 19C7.31078 19 3.5 15 2 12C2 12 3.5 9 6.5 6.91847',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M9.85786 10C9.32783 10.53 9 11.2623 9 12.0711C9 13.6887 10.3113 15 11.9289 15C12.7377 15 13.47 14.6722 14 14.1421',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    ['path', { d: 'M3 3L21 21', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
  ],
  /** File02Icon */
  document: [
    ['path', { d: 'M8 17H16', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M8 13H12', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    [
      'path',
      { d: 'M13 2.5V9H19.5M20 9V22H4V2H13L20 9Z', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
  ],
  /** Pdf01Icon */
  pdf: [
    [
      'path',
      { d: 'M20 13V9L13 2H4V13M13 2.5V9H19.5', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
    [
      'path',
      {
        d: 'M20 16H16.5V19M16.5 19V22M16.5 19H19.5M4.5 22V19.5M4.5 19.5V16H6.25C7.2165 16 8 16.7835 8 17.75C8 18.7165 7.2165 19.5 6.25 19.5H4.5ZM10.5 16H12C13.1046 16 14 16.8954 14 18V20C14 21.1046 13.1046 22 12 22H10.5V16Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** Png01Icon */
  png: [
    [
      'path',
      { d: 'M20 13V9L13 2H4V13M13 2.5V9H19.5', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
    [
      'path',
      {
        d: 'M4 22V19M4 19V16H6C6.82843 16 7.5 16.6716 7.5 17.5C7.5 18.3284 6.82843 19 6 19H4ZM20 17V16H16.5V22H20V19.5H19M10 22V16H10.1883L13.8148 22H14V16',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** Xls01Icon */
  spreadsheet: [
    ['path', { d: 'M10.5 16V22H14', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    [
      'path',
      {
        d: 'M4 16L6 19M6 19L8 22M6 19L8 16M6 19L4 22',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      { d: 'M20.0002 16H16.5V19H20.0002V22H16.5', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
    [
      'path',
      { d: 'M20 13V9L13 2H4V13M13 2.5V9H19.5', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
  ],
  /** Folder01Icon */
  folder: [
    [
      'path',
      {
        d: 'M8 6.99446H12.0179M12.0179 6.99446H22V21H2V3H9L12.0179 6.99446Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** Book02Icon */
  book: [
    [
      'path',
      { d: 'M15.5 7H8.5M12.499 11H8.49902', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
    [
      'path',
      {
        d: 'M20 22H6C4.89543 22 4 21.1046 4 20M4 20C4 18.8954 4.89543 18 6 18H20V2H6C4.89543 2 4 2.89543 4 4V20Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M19.5 18C19.5 18 18.5 18.7628 18.5 20C18.5 21.2372 19.5 22 19.5 22',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** FilterIcon */
  filter: [
    [
      'path',
      {
        d: 'M3.00073 3.10253V6.98276L9.00802 11.9828L9.9627 20.908C9.97018 20.9779 10.0454 21.0185 10.1078 20.9864L13.9732 18.996L15.0151 11.9828L20.9993 6.9692V3.10252C20.9993 3.04725 20.9545 3.00244 20.8993 3.00244L3.10069 3.00245C3.04548 3.00245 3.00073 3.04726 3.00073 3.10253Z',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** Search01Icon */
  search: [
    ['path', { d: 'M17 17L21 21', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    [
      'path',
      {
        d: 'M19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19C15.4183 19 19 15.4183 19 11Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** BubbleChatIcon */
  forum: [
    [
      'path',
      {
        d: 'M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C10.3719 21.5 8.8394 21.0904 7.5 20.3687C5.5 19.5 3.5 19.9125 2.5 20C2.98894 19.1667 3.60922 16.8818 2.98341 15C2.6698 14.057 2.5 13.0483 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M12.1257 12H12.0007M8.125 12H8M16.125 12H16M12.2507 12C12.2507 12.1381 12.1388 12.25 12.0007 12.25C11.8627 12.25 11.7507 12.1381 11.7507 12C11.7507 11.8619 11.8627 11.75 12.0007 11.75C12.1388 11.75 12.2507 11.8619 12.2507 12ZM8.25 12C8.25 12.1381 8.13807 12.25 8 12.25C7.86193 12.25 7.75 12.1381 7.75 12C7.75 11.8619 7.86193 11.75 8 11.75C8.13807 11.75 8.25 11.8619 8.25 12ZM16.25 12C16.25 12.1381 16.1381 12.25 16 12.25C15.8619 12.25 15.75 12.1381 15.75 12C15.75 11.8619 15.8619 11.75 16 11.75C16.1381 11.75 16.25 11.8619 16.25 12Z',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** Comment01Icon */
  comment: [
    [
      'path',
      {
        d: 'M8.00476 12.5027H16.0113M8.00476 7.50024H12.008',
        stroke: 'currentColor',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M21.9991 2.00049H2.00085V17.9587H6.00291V21.9895C6.00291 21.9979 6.01267 22.0026 6.01921 21.9973L11.0143 17.9587H21.9991V2.00049Z',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** BubbleChatEditIcon */
  commentEdit: [
    [
      'path',
      {
        d: 'M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C10.3719 21.5 8.8394 21.0904 7.5 20.3687C5.5 19.5 3.5 19.9125 2.5 20C2.98894 19.1667 3.60922 16.8818 2.98341 15C2.6698 14.057 2.5 13.0483 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M10.3221 15.5H8.5V13.6779L13.4111 8.76684C13.7668 8.41105 14.3437 8.41105 14.6995 8.76684L15.2332 9.30052C15.5889 9.65631 15.5889 10.2332 15.2332 10.5889L10.3221 15.5Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** Message01Icon */
  message: [
    [
      'path',
      { d: 'M7.5 14.4736H16.5M7.5 9.48438H13', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' },
    ],
    [
      'path',
      {
        d: 'M2.00989 21.4487L6.58552 19.9807C8.08688 20.8109 9.78899 20.9937 11.6746 20.9937C18.1751 21.4487 21.9977 17.2443 21.9977 12.2602C22.1047 7.30419 19.9149 2.0807 11.5775 2.46969C4.30503 2.59894 2.00391 7.03781 2.00391 12.0219C2.00391 13.7262 2.35123 15.8127 3.60536 17.452L2.00989 21.4487ZM2.00989 21.4487C2.0025 21.4505 2.0079 21.4554 2.00989 21.4487Z',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** NoteEditIcon */
  post: [
    [
      'path',
      {
        d: 'M15.4996 2V5M6.49959 2V5M10.9996 2V5',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M18.9996 12V3.5L2.99959 3.5V22H10.9996',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M6.99959 15H10.9996M6.99959 11H14.9996',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M15.8217 22H13.9996V20.1779L18.9106 15.2668C19.2664 14.9111 19.8433 14.9111 20.1991 15.2668L20.7327 15.8005C21.0885 16.1563 21.0885 16.7332 20.7327 17.0889L15.8217 22Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** Megaphone01Icon */
  announcement: [
    [
      'path',
      {
        d: 'M9.00061 14.0001V6.00012H4.50061C3.1199 6.00012 2.00061 7.11941 2.00061 8.50012V11.5001C2.00061 12.8808 3.1199 14.0001 4.50061 14.0001H9.00061Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M9.96527 18.8234L9.00061 14.0001H5.50061L6.71961 19.6888C6.88351 20.4537 7.55946 21.0001 8.3417 21.0001C9.25789 21.0001 10.0006 20.2574 10.0006 19.3412V19.1803C10.0006 19.0605 9.98877 18.9409 9.96527 18.8234Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M10.0006 6.00012H9.00061V14.0001H10.0006C11.2988 14.0001 12.562 14.4212 13.6006 15.2001L16.0006 17.0001H17.0006C17.3455 15.8574 18.0006 13.2729 18.0006 10.0001C18.0006 6.7273 17.3455 4.14286 17.0006 3.00012H16.0006L13.6006 4.80012C12.562 5.57905 11.2988 6.00012 10.0006 6.00012Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M21.0006 10.0001H22.0006M20.5006 6.00121L21.5006 5.40649M20.5006 14.0001L21.5006 14.6482',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** ThumbsUpIcon */
  like: [
    [
      'path',
      {
        d: 'M2.00171 10.4982V20.4982H7.00171V10.4982H2.00171Z',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M7.00171 10.5023V20.4882C7.00171 20.4937 7.00619 20.4982 7.01171 20.4982H19.0017L21.9978 10.5111C21.9998 10.5046 21.995 10.4982 21.9883 10.4982H14.5017L16 5.5039C16.001 5.50037 16.0001 5.49655 15.9975 5.49395L14.0088 3.50525C14.0049 3.50134 13.9985 3.50134 13.9946 3.50525L7.00464 10.4952C7.00276 10.4971 7.00171 10.4997 7.00171 10.5023Z',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** FavouriteIcon */
  favourite: [
    [
      'path',
      {
        d: 'M12 20.5C12 20.5 2 14.5 2 8.69444C2 5.82563 4.10526 3.5 7 3.5C8.5 3.5 10 4 12 6C14 4 15.5 3.5 17 3.5C19.8947 3.5 22 5.82563 22 8.69444C22 14.5 12 20.5 12 20.5Z',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** Share08Icon */
  share: [
    [
      'path',
      {
        d: 'M21 6.5C21 8.15685 19.6569 9.5 18 9.5C16.3431 9.5 15 8.15685 15 6.5C15 4.84315 16.3431 3.5 18 3.5C19.6569 3.5 21 4.84315 21 6.5Z',
        stroke: 'currentColor',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12Z',
        stroke: 'currentColor',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M21 17.5C21 19.1569 19.6569 20.5 18 20.5C16.3431 20.5 15 19.1569 15 17.5C15 15.8431 16.3431 14.5 18 14.5C19.6569 14.5 21 15.8431 21 17.5Z',
        stroke: 'currentColor',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M8.72852 10.7495L15.2285 7.75M8.72852 13.25L15.2285 16.2495',
        stroke: 'currentColor',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** Link01Icon */
  link: [
    [
      'path',
      {
        d: 'M9.14339 10.691L9.35031 10.4841C11.329 8.50532 14.5372 8.50532 16.5159 10.4841C18.4947 12.4628 18.4947 15.671 16.5159 17.6497L13.6497 20.5159C11.671 22.4947 8.46279 22.4947 6.48405 20.5159C4.50532 18.5372 4.50532 15.329 6.48405 13.3503L6.9484 12.886',
        stroke: 'currentColor',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M17.0516 11.114L17.5159 10.6497C19.4947 8.67095 19.4947 5.46279 17.5159 3.48405C15.5372 1.50532 12.329 1.50532 10.3503 3.48405L7.48405 6.35031C5.50532 8.32904 5.50532 11.5372 7.48405 13.5159C9.46279 15.4947 12.671 15.4947 14.6497 13.5159L14.8566 13.309',
        stroke: 'currentColor',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** LinkSquare02Icon */
  externalLink: [
    ['path', { d: 'M12 3H2.99995V21H21V12', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    [
      'path',
      {
        d: 'M10.9882 13.0016L20.5838 3.41584M20.9998 8.99185L21 3H15.0108',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** PinIcon */
  pin: [
    ['path', { d: 'M3 21L9 15', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    [
      'path',
      {
        d: 'M15.504 3C15.504 3 14.9662 3.72435 14.5056 4.57662C13.9332 5.6355 13.4887 6.97441 12.6486 7.84609C12.6486 7.84609 11.1254 7.72792 9.41785 7.53514C7.66749 7.33753 6.46752 8.01179 4.96344 9.54338L4 10.5057L13.4937 20L14.4571 19.0377C15.9892 17.5342 16.6628 16.3335 16.4652 14.583C16.2724 12.8753 16.1543 11.352 16.1543 11.352C17.0259 10.5118 18.3647 10.0673 19.4235 9.49492C20.2757 9.03424 21 8.49636 21 8.49636C20.9336 6.97368 20.3961 5.77286 19.3119 4.68823C18.2273 3.6039 17.0266 3.06639 15.504 3Z',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** HashtagIcon */
  hashtag: [
    ['path', { d: 'M14 21L18 3', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M6 21L10 3', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M5 8H21', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M3 16H19', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
  ],
  /** PencilEdit01Icon */
  edit: [
    [
      'path',
      {
        d: 'M14 7L5 16L4 20L8 19L17 10M14 7L17 4L20 7L17 10M14 7L17 10',
        stroke: 'currentColor',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
    ['path', { d: 'M11 20H18', stroke: 'currentColor', strokeWidth: '1.5' }],
  ],
  /** Add01Icon */
  add: [
    ['path', { d: 'M12.001 5.00003V19.002', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    [
      'path',
      { d: 'M19.002 12.002L4.99998 12.002', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
  ],
  /** AddSquareIcon */
  addSquare: [
    [
      'path',
      {
        d: 'M2.5 21.5L21.5 21.5L21.5 2.5L2.50001 2.5L2.5 21.5Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    ['path', { d: 'M12 8V16M16 12H8', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
  ],
  /** Delete02Icon */
  delete: [
    [
      'path',
      { d: 'M19.5 5.5L18.5 22H5.5L4.5 5.5', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' },
    ],
    [
      'path',
      {
        d: 'M2 5.5H8M22 5.5H16M16 5.5L14.5 2H9.5L8 5.5M16 5.5H8',
        stroke: 'currentColor',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
    ['path', { d: 'M9.5 16.5L9.5 10.5', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M14.5 16.5L14.5 10.5', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
  ],
  /** Cancel01Icon */
  close: [
    [
      'path',
      {
        d: 'M18 6L6.00081 17.9992M17.9992 18L6 6.00085',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** Tick02Icon */
  check: [
    [
      'path',
      { d: 'M5 13.9998L8.5 17.4998L19 6.49982', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
  ],
  /** CheckmarkSquare02Icon */
  checkSquare: [
    ['path', { d: 'M21 3V21H3V3H21Z', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M8 12.5L10.5 15L16 9', stroke: 'currentColor', strokeWidth: '1.5' }],
  ],
  /** CheckmarkCircle02Icon */
  success: [
    [
      'path',
      {
        d: 'M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
    ['path', { d: 'M8 12.5L10.5 15L16 9', stroke: 'currentColor', strokeWidth: '1.5' }],
  ],
  /** CheckmarkBadge01Icon */
  verified: [
    [
      'path',
      {
        d: 'M4.9971 5.0071C4.9971 5.00158 5.00158 4.9971 5.0071 4.9971H8.99876L11.9929 2.00293C11.9968 1.99902 12.0032 1.99902 12.0071 2.00293L15.0012 4.9971H18.9929C18.9984 4.9971 19.0029 5.00158 19.0029 5.0071V8.99876L21.9971 11.9929C22.001 11.9968 22.001 12.0032 21.9971 12.0071L19.0029 15.0012V18.9929C19.0029 18.9984 18.9984 19.0029 18.9929 19.0029H15.0012L12.0071 21.9971C12.0032 22.001 11.9968 22.001 11.9929 21.9971L9.00169 19.0058C8.99981 19.004 8.99727 19.0029 8.99461 19.0029H5.0071C5.00158 19.0029 4.9971 18.9984 4.9971 18.9929V15.0012L2.00293 12.0071C1.99902 12.0032 1.99902 11.9968 2.00293 11.9929L4.9971 8.99876V5.0071Z',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M9 12.8929C9 12.8929 10.2 13.5447 10.8 14.5C10.8 14.5 12.6 10.75 15 9.5',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** InformationCircleIcon */
  info: [
    ['circle', { cx: '12', cy: '12', r: '10', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M12 16V12', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    [
      'path',
      {
        d: 'M12.125 8.25H12M12.25 8.25C12.25 8.11193 12.1381 8 12 8C11.8619 8 11.75 8.11193 11.75 8.25C11.75 8.38807 11.8619 8.5 12 8.5C12.1381 8.5 12.25 8.38807 12.25 8.25Z',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** HelpCircleIcon */
  help: [
    ['circle', { cx: '12', cy: '12', r: '10', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    [
      'path',
      {
        d: 'M9.5 9.5C9.5 8.11929 10.6193 7 12 7C13.3807 7 14.5 8.11929 14.5 9.5C14.5 10.3569 14.0689 11.1131 13.4117 11.5636C12.7283 12.0319 12 12.6716 12 13.5',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M12.125 16.75H12M12.25 16.75C12.25 16.8881 12.1381 17 12 17C11.8619 17 11.75 16.8881 11.75 16.75C11.75 16.6119 11.8619 16.5 12 16.5C12.1381 16.5 12.25 16.6119 12.25 16.75Z',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** Alert02Icon */
  warning: [
    [
      'path',
      { d: 'M2 20.9995H22L12 3L2 20.9995Z', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
    ['path', { d: 'M12 10.5V14.5', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    [
      'path',
      {
        d: 'M12.125 17.751H12M12.25 17.751C12.25 17.889 12.1381 18.001 12 18.001C11.8619 18.001 11.75 17.889 11.75 17.751C11.75 17.6129 11.8619 17.501 12 17.501C12.1381 17.501 12.25 17.6129 12.25 17.751Z',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** AlertCircleIcon */
  error: [
    ['circle', { cx: '12', cy: '12', r: '10', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M12 8V12', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    [
      'path',
      {
        d: 'M12.125 15.75H12M12.25 15.75C12.25 15.8881 12.1381 16 12 16C11.8619 16 11.75 15.8881 11.75 15.75C11.75 15.6119 11.8619 15.5 12 15.5C12.1381 15.5 12.25 15.6119 12.25 15.75Z',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** UnavailableIcon */
  blocked: [
    [
      'path',
      { d: 'M5.58301 5.3335L18.9163 18.6668', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' },
    ],
    [
      'path',
      {
        d: 'M22.25 12C22.25 6.47715 17.7728 2 12.25 2C6.72715 2 2.25 6.47715 2.25 12C2.25 17.5228 6.72715 22 12.25 22C17.7728 22 22.25 17.5228 22.25 12Z',
        stroke: 'currentColor',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** Clock01Icon */
  pending: [
    ['circle', { cx: '12', cy: '12', r: '10', stroke: 'currentColor', strokeWidth: '1.5' }],
    ['path', { d: 'M12 7V12L14.5 14.5', stroke: 'currentColor', strokeWidth: '1.5' }],
  ],
  /** TaskDaily01Icon */
  tasks: [
    [
      'path',
      { d: 'M15.5 3.5H20V22L3 22V3.5H7.5', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
    ['path', { d: 'M15.5 2H7.5V5H15.5V2Z', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M13.5 11H16.5', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M6.5 10.5L8 12L11 9', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M13.5 17H16.5', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    [
      'path',
      {
        d: 'M8.625 17H8.5M8.75 17C8.75 17.1381 8.63807 17.25 8.5 17.25C8.36193 17.25 8.25 17.1381 8.25 17C8.25 16.8619 8.36193 16.75 8.5 16.75C8.63807 16.75 8.75 16.8619 8.75 17Z',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** HistoryIcon */
  history: [
    [
      'path',
      {
        d: 'M4.20815 14.7185L3.9611 14.0104L2.54481 14.5044L2.79185 15.2126L3.5 14.9656L4.20815 14.7185ZM21 12H20.25C20.25 16.5563 16.5563 20.25 12 20.25V21V21.75C17.3848 21.75 21.75 17.3848 21.75 12H21ZM12 3V3.75C16.5563 3.75 20.25 7.44365 20.25 12H21H21.75C21.75 6.61522 17.3848 2.25 12 2.25V3ZM3.5 9L4.21151 9.23717C4.65456 7.90804 5.69306 6.5272 7.10355 5.47645C8.50945 4.42912 10.2309 3.75 12 3.75V3V2.25C9.85037 2.25 7.82186 3.07088 6.20744 4.27355C4.59761 5.4728 3.34544 7.09196 2.78849 8.76283L3.5 9ZM12 21V20.25C8.39726 20.25 5.33207 17.9402 4.20815 14.7185L3.5 14.9656L2.79185 15.2126C4.11939 19.018 7.73967 21.75 12 21.75V21Z',
        fill: 'currentColor',
      },
    ],
    ['path', { d: 'M7.5 9H3V4', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M12 7V12L15 14', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
  ],
  /** RefreshIcon */
  refresh: [
    [
      'path',
      {
        d: 'M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C15.2716 2 18.1763 3.57111 20.0007 6V2',
        stroke: 'currentColor',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** ArchiveRestoreIcon */
  restore: [
    ['path', { d: 'M20 8V21H16M4 8V21H8', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M22 3H2V8H22V3Z', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    [
      'path',
      { d: 'M15 15L12 12L9 15M12 12.5V21', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
  ],
  /** SquareLock02Icon */
  lock: [
    [
      'path',
      {
        d: 'M19.9995 8.99994H3.99951V21.9999H19.9995V8.99994Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M16.4995 8.99994V6.49994C16.4995 4.01466 14.4848 1.99994 11.9995 1.99994C9.51423 1.99994 7.49951 4.01466 7.49951 6.49994V8.99994',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M11.9995 14.4999V17.4999M12.9995 14.4999C12.9995 15.0522 12.5518 15.4999 11.9995 15.4999C11.4472 15.4999 10.9995 15.0522 10.9995 14.4999C10.9995 13.9477 11.4472 13.4999 11.9995 13.4999C12.5518 13.4999 12.9995 13.9477 12.9995 14.4999Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** SquareUnlock02Icon */
  unlock: [
    ['path', { d: 'M20 9H4V22H20V9Z', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    [
      'path',
      {
        d: 'M12 14.5V17.5M13 14.5C13 15.0523 12.5523 15.5 12 15.5C11.4477 15.5 11 15.0523 11 14.5C11 13.9477 11.4477 13.5 12 13.5C12.5523 13.5 13 13.9477 13 14.5Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M7.5 9V6.5C7.5 4.01472 9.51472 2 12 2C13.9593 2 15.8664 3.25221 16.5 5',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** SecurityCheckIcon */
  security: [
    [
      'path',
      {
        d: 'M20.9976 5C18.8762 3.17002 15.6326 2 11.9976 2C8.3625 2 5.11893 3.17002 2.99756 5V11C2.99756 19 11.9975 22 11.9975 22C11.9975 22 20.9975 19 20.9975 11L20.9976 5Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M8.99756 11.5L10.9976 13.5L14.9976 9.5',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** Shield01Icon */
  shield: [
    [
      'path',
      {
        d: 'M21 5C18.8786 3.17002 15.6351 2 12 2C8.36494 2 5.12137 3.17002 3 5V11C3 19 12 22 12 22C12 22 21 19 21 11L21 5Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** UserIcon */
  user: [
    [
      'path',
      {
        d: 'M20 21.0001C19.713 17.269 16.7289 14.3151 12.995 14.0662L12 13.9999C11.6446 14.0096 11.3134 14.0225 11.0008 14.0378C7.3 14.2192 4.28417 17.3057 4 21.0001',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'circle',
      { cx: '12', cy: '6.99988', r: '4', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
  ],
  /** UserGroupIcon */
  users: [
    [
      'path',
      {
        d: 'M18.4995 20.5C18.2663 17.5685 15.8417 15.2477 12.8079 15.0521L11.9994 15C11.7107 15.0076 11.4415 15.0178 11.1876 15.0298C8.18069 15.1723 5.73034 17.5974 5.49945 20.5',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M15.2494 9.25C15.2494 11.0449 13.7944 12.5 11.9995 12.5C10.2045 12.5 8.74946 11.0449 8.74946 9.25C8.74946 7.45507 10.2045 6 11.9995 6C13.7944 6 15.2494 7.45507 15.2494 9.25Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M5.50249 8.5C5.17908 7.99485 4.99158 7.39432 4.99158 6.75C4.99158 4.95507 6.44665 3.5 8.24157 3.5C8.68752 3.5 9.1125 3.58982 9.49939 3.75235',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M18.4963 8.5C18.8197 7.99485 19.0072 7.39432 19.0072 6.75C19.0072 4.95507 17.5521 3.5 15.7572 3.5C15.3113 3.5 14.8863 3.58982 14.4994 3.75235',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M22.0007 17.9996C21.8207 15.7374 19.9995 13.5 17.9995 13',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M1.99927 17.9996C2.17923 15.7374 4.00049 13.5 6.00049 13',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** UserMultipleIcon */
  people: [
    [
      'path',
      {
        d: 'M16 21C15.7668 18.0685 13.3422 15.7477 10.3085 15.5521L9.49999 15.5C9.21121 15.5076 8.94209 15.5178 8.68816 15.5298C5.68124 15.6723 3.23089 18.0974 3 21',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M12.75 9.75C12.75 11.5449 11.2949 13 9.5 13C7.70508 13 6.25 11.5449 6.25 9.75C6.25 7.95507 7.70508 6.5 9.5 6.5C11.2949 6.5 12.75 7.95507 12.75 9.75Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M21 17.501C20.7709 14.6314 18.4541 12.2748 15.5 11.9961',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M15.9876 9C16.8964 8.42434 17.5001 7.40788 17.5001 6.25C17.5001 4.45507 16.0495 3 14.2602 3C13.3811 3 12.5838 3.35121 12.0001 3.92139',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** UserAdd01Icon */
  userAdd: [
    [
      'path',
      {
        d: 'M3 20.5002C3.28417 16.8058 6.3 13.7193 10.0008 13.5379C10.3134 13.5226 10.6446 13.5097 11 13.5L11.995 13.5663C12.6939 13.6129 13.3665 13.7543 14 13.9777',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      { d: 'M18 15.5V21.5M21 18.5L15 18.5', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
    ['circle', { cx: '11', cy: '6.5', r: '4', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
  ],
  /** UserCheck01Icon */
  userCheck: [
    [
      'path',
      {
        d: 'M3 21.0001C3.28417 17.3057 6.3 14.2192 10.0008 14.0378C10.3134 14.0225 10.6446 14.0096 11 13.9999L11.995 14.0662C13.0751 14.1382 14.0925 14.4366 15 14.9146',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'circle',
      { cx: '11', cy: '6.99988', r: '4', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
    [
      'path',
      { d: 'M14 18.9999L16 20.9999L21 15.9999', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
  ],
  /** UserSettings01Icon */
  userSettings: [
    [
      'path',
      {
        d: 'M11 13.5C10.6446 13.5097 10.3134 13.5226 10.0008 13.5379C6.3 13.7193 3.28417 16.8058 3 20.5002',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M19.6709 16.2593C19.8803 16.6249 20 17.0485 20 17.5C20 17.9514 19.8804 18.3749 19.671 18.7404C19.2402 19.493 18.4293 20 17.5 20M15.3291 16.2593C15.1197 16.6249 15 17.0485 15 17.5C15 17.9514 15.1196 18.3749 15.329 18.7404C15.7598 19.493 16.5707 20 17.5 20M17.5 20L17.5 21.5M17.5 15C18.4292 15 19.24 15.5069 19.6709 16.2593M17.5 15C16.5708 15 15.76 15.5069 15.3291 16.2593M17.5 15L17.5 13.5M21 15.4998L19.6709 16.2593M14 19.4998L15.329 18.7404M21 19.4998L19.671 18.7404M14 15.4998L15.3291 16.2593',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    ['circle', { cx: '11', cy: '6.5', r: '4', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
  ],
  /** ManagerIcon */
  officer: [
    [
      'path',
      {
        d: 'M20 22.0002V14.5002L16.5 13.0002H16L12.5 22.0002H11.5L8 13.0002H7.5L4 14.5002V22.0002',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M12 15L11.5 19L12 20.5L12.5 19L12 15ZM12 15L11 13H13L12 15Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M15.5 6.50012V5.50012C15.5 3.56713 13.933 2.00012 12 2.00012C10.067 2.00012 8.5 3.56713 8.5 5.50012V6.50012C8.5 8.43312 10.067 10.0001 12 10.0001C13.933 10.0001 15.5 8.43312 15.5 6.50012Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** RankingIcon */
  rank: [
    [
      'path',
      { d: 'M9 14.9915H3.5V22.0003H9V14.9915Z', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' },
    ],
    [
      'path',
      {
        d: 'M20.5 16.9941H15V22.0005H20.5V16.9941Z',
        stroke: 'currentColor',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      { d: 'M15 12.9888H9V22.0002H15V12.9888Z', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' },
    ],
    ['path', { d: 'M2 22.0005H22', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    [
      'path',
      {
        d: 'M11.9606 2.01997C11.9806 1.9927 12.0213 1.99269 12.0412 2.01995L13.6899 4.26825L16.5032 5.01125C16.5103 5.01311 16.513 5.02165 16.5084 5.02729L14.6957 7.23599L14.7795 9.9213C14.7806 9.9562 14.7466 9.98146 14.7135 9.9703L12.0009 9.05339L9.29494 9.97037C9.26201 9.98153 9.22804 9.95646 9.22893 9.92166L9.29755 7.23599L7.56682 5.09299C7.54414 5.0649 7.55771 5.02274 7.59251 5.01322L10.3139 4.26825L11.9606 2.01997Z',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** Briefcase01Icon */
  briefcase: [
    [
      'path',
      {
        d: 'M2.00121 8.5L1.99866 20.9995L22.0011 21L22.0012 8.5',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    ['path', { d: 'M15.4987 6.5V3H8.49875V6.5', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    [
      'path',
      {
        d: 'M1.99875 6.5V9.50039C1.99875 11.1572 3.34189 12.5004 4.99875 12.5004H18.9983C20.6551 12.5004 21.9983 11.1572 21.9983 9.50039V6.5H1.99875Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      { d: 'M9.99875 12.5V15.5H13.9987V12.5', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
  ],
  /** SailboatOffshoreIcon */
  vessel: [
    [
      'path',
      {
        d: 'M6 19C3.6 17.4 3 15.3333 3 14L21 14C21 15.3333 20.4 17.4 18 19',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
    ['path', { d: 'M14 2L18 9.99999L7 10L14 2Z', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M14 14L14 2', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    [
      'path',
      {
        d: 'M2 21.6083C2.79944 22.106 3.83288 22.106 4.65182 21.6083C5.95823 20.7972 7.6546 20.7972 8.9805 21.6083C8.9805 21.6267 9.00001 21.6267 9.00001 21.6267C9.79945 22.1244 10.8524 22.1244 11.6518 21.6267C12.9777 20.8157 14.6741 20.8157 16 21.6267C16.7994 22.1244 17.8329 22.106 18.6518 21.6083C19.6529 20.9868 20.8831 20.8415 22 21.1726',
        stroke: 'currentColor',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** EngineIcon */
  engine: [
    ['path', { d: 'M2 9V15', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    [
      'path',
      {
        d: 'M5 16V8H16V11H19V8H22V18H19V14H16V18H8L5 16Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    ['path', { d: 'M5 12H2', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M10.5 8V5', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M7 5H14', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
  ],
  /** Location01Icon */
  location: [
    [
      'path',
      {
        d: 'M15.5 11C15.5 12.933 13.933 14.5 12 14.5C10.067 14.5 8.5 12.933 8.5 11C8.5 9.067 10.067 7.5 12 7.5C13.933 7.5 15.5 9.067 15.5 11Z',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M21 11C21 18 12 22 12 22C12 22 3 18 3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11Z',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** MapsLocation01Icon */
  map: [
    [
      'path',
      {
        d: 'M22 9.99902V4.99902H15L8.01175 2L2 5.08199V18.999L8.01175 16.999L11 18.2818',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    ['path', { d: 'M8.00001 2.5L8 17.0004', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M15 5V9.5', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    [
      'path',
      {
        d: 'M22 16.5C22 20 17.5 22 17.5 22C17.5 22 13 20 13 16.5C13 14.0147 15.0147 12 17.5 12C19.9853 12 22 14.0147 22 16.5Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M17.625 16.5H17.5M17.75 16.5C17.75 16.6381 17.6381 16.75 17.5 16.75C17.3619 16.75 17.25 16.6381 17.25 16.5C17.25 16.3619 17.3619 16.25 17.5 16.25C17.6381 16.25 17.75 16.3619 17.75 16.5Z',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** QrCodeIcon */
  qrCode: [
    ['path', { d: 'M3.00873 11.9902H9.00278', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M11.9999 3.00195V7.99558', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    [
      'path',
      {
        d: 'M8.93144 3.01855H3.10003C3.04485 3.01855 3.00013 3.06327 3.00012 3.11842L2.99994 8.92085C2.99994 8.97601 3.04467 9.02073 3.09984 9.02073H8.93144C8.98661 9.02073 9.03134 8.97601 9.03134 8.92086V3.11843C9.03134 3.06327 8.98662 3.01855 8.93144 3.01855Z',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M8.93144 14.96H3.10003C3.04485 14.96 3.00013 15.0047 3.00012 15.0598L2.99994 20.8623C2.99994 20.9174 3.04467 20.9621 3.09984 20.9621H8.93144C8.98661 20.9621 9.03134 20.9174 9.03134 20.8623V15.0598C9.03134 15.0047 8.98662 14.96 8.93144 14.96Z',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M20.9861 11.9893H12.0784C12.0232 11.9893 11.9785 12.034 11.9785 12.0891V14.9851M11.9974 17.0043V19.9654M13.9957 20.9988H15.9849M17.9862 20.9749H20.8872C20.9424 20.9749 20.9871 20.9301 20.9871 20.875V15.0824C20.9871 15.0272 20.9424 14.9825 20.8872 14.9825H17.994M14.9891 14.9825V17.4793H17.994V18.9787',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M20.9002 3.01855H15.0688C15.0136 3.01855 14.9689 3.06332 14.9689 3.11855L14.9687 8.92838C14.9687 8.98361 15.0134 9.02839 15.0686 9.02839H20.9002C20.9554 9.02839 21.0001 8.98362 21.0001 8.92839V3.11855C21.0001 3.06333 20.9554 3.01855 20.9002 3.01855Z',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** Menu01Icon */
  menu: [
    ['path', { d: 'M4 5L20 5', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M4 12L20 12', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M4 19L20 19', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
  ],
  /** MoreHorizontalIcon */
  more: [
    [
      'path',
      {
        d: 'M6.00449 12.5V12M18.0045 12.5V12M12.0045 12.5V12M7.00449 12.5C7.00449 11.9477 6.55677 11.5 6.00449 11.5C5.4522 11.5 5.00449 11.9477 5.00449 12.5C5.00449 13.0523 5.4522 13.5 6.00449 13.5C6.55677 13.5 7.00449 13.0523 7.00449 12.5ZM19.0045 12.5C19.0045 11.9477 18.5568 11.5 18.0045 11.5C17.4522 11.5 17.0045 11.9477 17.0045 12.5C17.0045 13.0523 17.4522 13.5 18.0045 13.5C18.5568 13.5 19.0045 13.0523 19.0045 12.5ZM13.0045 12.5C13.0045 11.9477 12.5568 11.5 12.0045 11.5C11.4522 11.5 11.0045 11.9477 11.0045 12.5C11.0045 13.0523 11.4522 13.5 12.0045 13.5C12.5568 13.5 13.0045 13.0523 13.0045 12.5Z',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** MoreVerticalIcon */
  moreVertical: [
    [
      'path',
      {
        d: 'M11.9967 12.5V12M11.9967 6.5V6M11.9967 18.5V18M12.9967 12.5C12.9967 11.9477 12.549 11.5 11.9967 11.5C11.4444 11.5 10.9967 11.9477 10.9967 12.5C10.9967 13.0523 11.4444 13.5 11.9967 13.5C12.549 13.5 12.9967 13.0523 12.9967 12.5ZM12.9967 6.5C12.9967 5.94772 12.549 5.5 11.9967 5.5C11.4444 5.5 10.9967 5.94772 10.9967 6.5C10.9967 7.05228 11.4444 7.5 11.9967 7.5C12.549 7.5 12.9967 7.05228 12.9967 6.5ZM12.9967 18.5C12.9967 17.9477 12.549 17.5 11.9967 17.5C11.4444 17.5 10.9967 17.9477 10.9967 18.5C10.9967 19.0523 11.4444 19.5 11.9967 19.5C12.549 19.5 12.9967 19.0523 12.9967 18.5Z',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** DragDropVerticalIcon */
  drag: [
    [
      'path',
      { d: 'M16 11L16 13H14L14 11L16 11Z', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
    [
      'path',
      { d: 'M16 17L16 19H14L14 17L16 17Z', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
    [
      'path',
      {
        d: 'M15.9981 5L15.998 7H13.998L13.998 5L15.9981 5Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    ['path', { d: 'M10 11L10 13H8L8 11L10 11Z', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M10 17L10 19H8L8 17L10 17Z', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M10 5L10 7H8L8 5L10 5Z', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
  ],
  /** TextBoldIcon */
  bold: [
    [
      'path',
      {
        d: 'M5.59501 11.9627H13.2636M5.59501 11.9627V3L12.6148 3.00098C15.47 3.00098 17.4212 4.68253 17.4212 7.20527C17.4212 9.72801 16.1187 11.9627 13.2636 11.9627M5.59501 11.9627L5.5 20.992H13.5859C16.6605 21.1358 18.4995 19.0533 18.4995 16.5305C18.4995 14.0078 16.7135 11.9627 13.2636 11.9627',
        stroke: 'currentColor',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** TextItalicIcon */
  italic: [
    ['path', { d: 'M11 4H18', stroke: 'currentColor', strokeWidth: '1.5' }],
    ['path', { d: 'M10 20L15 4', stroke: 'currentColor', strokeWidth: '1.5' }],
    ['path', { d: 'M7 20H14', stroke: 'currentColor', strokeWidth: '1.5' }],
  ],
  /** LeftToRightListBulletIcon */
  bulletList: [
    ['path', { d: 'M8 5.5L20 5.5', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M8 12.5L20 12.5', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M8 19.5L20 19.5', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    [
      'path',
      {
        d: 'M4.375 5.5H4.25M4.5 5.5C4.5 5.63807 4.38807 5.75 4.25 5.75C4.11193 5.75 4 5.63807 4 5.5C4 5.36193 4.11193 5.25 4.25 5.25C4.38807 5.25 4.5 5.36193 4.5 5.5Z',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M4.375 12.5H4.25M4.5 12.5C4.5 12.6381 4.38807 12.75 4.25 12.75C4.11193 12.75 4 12.6381 4 12.5C4 12.3619 4.11193 12.25 4.25 12.25C4.38807 12.25 4.5 12.3619 4.5 12.5Z',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M4.375 19.5H4.25M4.5 19.5C4.5 19.6381 4.38807 19.75 4.25 19.75C4.11193 19.75 4 19.6381 4 19.5C4 19.3619 4.11193 19.25 4.25 19.25C4.38807 19.25 4.5 19.3619 4.5 19.5Z',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
  ],
  /** LeftToRightListNumberIcon */
  numberedList: [
    ['path', { d: 'M10.5 6L20.5 6', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M10.5 12L20.5 12', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M10.5 18L20.5 18', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    [
      'path',
      {
        d: 'M3.5 15H6.5V18H3.50034V21H6.5',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
    ['path', { d: 'M3.5 3H5V9M5 9H3.5M5 9H6.5', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
  ],
  /** Image01Icon */
  image: [
    [
      'circle',
      {
        cx: '8.5',
        cy: '8.5',
        r: '1.5',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
    ['path', { d: 'M21 21V3H3V21H21Z', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M5 21L15 12L21 16', stroke: 'currentColor', strokeWidth: '1.5' }],
  ],
  /** Unlink01Icon */
  unlink: [
    [
      'path',
      {
        d: 'M12.1434 10.691L12.3503 10.4841C14.329 8.50532 17.5372 8.50532 19.5159 10.4841C21.4947 12.4628 21.4947 15.671 19.5159 17.6497L16.6497 20.5159C14.671 22.4947 11.4628 22.4947 9.48405 20.5159C7.50532 18.5372 7.50532 15.329 9.48405 13.3503L9.9484 12.886',
        stroke: 'currentColor',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M20.0516 11.114L20.5159 10.6497C22.4947 8.67095 22.4947 5.46279 20.5159 3.48405C18.5372 1.50532 15.329 1.50532 13.3503 3.48405L10.4841 6.35031C8.50532 8.32904 8.50532 11.5372 10.4841 13.5159C12.4628 15.4947 15.671 15.4947 17.6497 13.5159L17.8566 13.309',
        stroke: 'currentColor',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      { d: 'M4.5 4L6 6M2 8L5 9M3 13.5L5 12', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' },
    ],
  ],
  /** HeadingIcon */
  heading: [
    ['path', { d: 'M6 4V20', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M18 4V20', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M6 12H18', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
  ],
  /** TextUnderlineIcon */
  underline: [
    [
      'path',
      {
        d: 'M5.5 3V11.5C5.5 15.0899 8.41015 18 12 18C15.5899 18 18.5 15.0899 18.5 11.5V3',
        stroke: 'currentColor',
        strokeLinejoin: 'round',
        strokeWidth: '1.5',
      },
    ],
    ['path', { d: 'M3 21H21', stroke: 'currentColor', strokeWidth: '1.5' }],
  ],
  /** TextAlignLeftIcon */
  alignLeft: [
    ['path', { d: 'M3 3H21', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M3 9H11', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M3 15H21', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M3 21H11', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
  ],
  /** TextAlignCenterIcon */
  alignCenter: [
    ['path', { d: 'M3 3H21', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M8 9H16', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M3 15H21', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M8 21H16', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
  ],
  /** TextAlignRightIcon */
  alignRight: [
    ['path', { d: 'M3 3H21', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M13 9H21', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M3 15H21', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
    ['path', { d: 'M13 21H21', stroke: 'currentColor', strokeLinejoin: 'round', strokeWidth: '1.5' }],
  ],
  /** CancelCircleIcon */
  cancelled: [
    [
      'path',
      {
        d: 'M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      { d: 'M14.9994 15L9 9M9.00064 15L15 9', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
  ],
  /** UserRemove01Icon */
  userRemove: [
    [
      'path',
      {
        d: 'M12.495 13.0662L11.5 12.9999C11.1446 13.0096 10.8134 13.0225 10.5008 13.0378C6.8 13.2192 3.78417 16.3057 3.5 20.0001',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M20.5 14.9999L18 17.4999M18 17.4999L15.5 19.9999M18 17.4999L20.5 19.9999M18 17.4999L15.5 14.9999',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'circle',
      { cx: '11.5', cy: '5.99988', r: '4', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' },
    ],
  ],
  /** TaskDone01Icon */
  taskDone: [
    [
      'path',
      {
        d: 'M11 21.9981L3.00004 21.9981L3 3.5L7.00004 3.5M15 3.5L19 3.5L19 14',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    [
      'path',
      {
        d: 'M13.5 2H8.5C7.67157 2 7 2.67157 7 3.5C7 4.32843 7.67157 5 8.5 5H13.5C14.3284 5 15 4.32843 15 3.5C15 2.67157 14.3284 2 13.5 2Z',
        stroke: 'currentColor',
        strokeLinecap: 'square',
        strokeWidth: '1.5',
      },
    ],
    ['path', { d: 'M7 15H10.4286M7 11H15', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
    ['path', { d: 'M21 17L16 22L14 20', stroke: 'currentColor', strokeLinecap: 'square', strokeWidth: '1.5' }],
  ],
} as const;

export type IconName = keyof typeof data;

export const icons: Record<IconName, IconData> = data;
